import { IssueResolutionTextAreaOptions } from './utils'
import { HelpMessage } from 'utils/constants'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import { CIMSFormItemProps } from 'components/CIMSFormItem/types'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSTextArea from 'components/CIMSTextArea'

const ResolutionFormItem: React.FC<Pick<CIMSFormItemProps, 'disabled'>> = ({
  disabled,
}) => {
  const [options, { some }] = useDisabledOptions(disabled)
  return (
    <CIMSFormItem
      name="resolution"
      label="Resolution"
      disabled={options}
      help={HelpMessage.FieldDesignChanges.FDCTracker.Resolution}
    >
      <CIMSTextArea disabled={some} {...IssueResolutionTextAreaOptions} />
    </CIMSFormItem>
  )
}

export default ResolutionFormItem
